import { render, staticRenderFns } from "./step_banking-security_providing_mobilization_needs.vue?vue&type=template&id=63e8ff1b&scoped=true"
import script from "./step_banking-security_providing_mobilization_needs.vue?vue&type=script&lang=js"
export * from "./step_banking-security_providing_mobilization_needs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e8ff1b",
  null
  
)

export default component.exports